import { get, post, put } from "./api_helper"

// branches
const getListPage = params => get("admin/master/company/page", params)
const getCompanyList = params => get("admin/master/company/list", params)
const getList = params => get("admin/master/customer/list", params)
const postData = params => post("admin/master/company", params)
const getDetail = id => get(`admin/master/company/${id}`)
const putData = params => put(`admin/master/company/${params.id}`, params)

const CompanyAPI = {
  getListPage,
  getList,
  postData,
  getDetail,
  putData,
  getCompanyList,
}

export default CompanyAPI
